import { Outlet } from '@remix-run/react';

//see equivalent component in advisor app for switch return statement
export const EditAccountLayoutPage = () => {
  return (

    <div className="-mx-6 md:mx-0">

      <Outlet />
    </div>
  );
};
